module.exports = __webpack_public_path__ + "img/20190808165734727.9ecc7858.png";